import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const legalEntitiesListFeatureKey = 'legalEntitiesList';

export interface LegalEntitiesListState {
  loadLegalEntitiesList: any;
  loadLegalEntitiesListResponse: any;
  loadLegalEntitiesListFailure: any;
  loaded: boolean;
  saveBusinessId: string;
}

export const initialState: LegalEntitiesListState = {
  loadLegalEntitiesList: undefined,
  loadLegalEntitiesListResponse: undefined,
  loadLegalEntitiesListFailure: undefined,
  loaded: false,
  saveBusinessId: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadLegalEntitiesLists, (state, action) => ({
    ...state,
    loadLegalEntitiesList: action.request
  })),
  on(actions.loadLegalEntitiesListsSuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesListResponse: action.response,
    loaded: true
  })),

  on(actions.clearLegalEntitiesList, (state, action) => ({
    ...state,
    loadLegalEntitiesListResponse: undefined,
    loaded: false
  })),

  on(actions.saveSelectedBusinessId, (state, action) => ({
    ...state,
    saveBusinessId: action.save
  })),
  on(actions.loadLegalEntitiesListsFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesListFailure: action.error,
    loaded: false
  })),
  on(actions.clearBusinessSelected, (state, action) => ({
    ...state,
    saveBusinessId: undefined,
    loaded: false
  }))
);

export const getLegalEntitiesList = (state: LegalEntitiesListState) => {
  let newArr;
  let parse;

  if (state.loadLegalEntitiesListResponse !== undefined) {
    const stringify = JSON.stringify(state.loadLegalEntitiesListResponse);
    parse = JSON.parse(stringify);
    return parse;
  }
};

export const getLegalEntitiesListIsLoaded = (state: LegalEntitiesListState) => state.loaded;

export const getSavedBusinessId = (state: LegalEntitiesListState) => state.saveBusinessId;
